import React, { useState, useEffect } from "react";
import ReactTableComponent from "../UniversalComponents/ReactTableComponent";
import { Dialog } from "@mui/material";
import { useLazyGetFieldsValueQuery } from "../../utils/customer/customerSelect";
import DynamicVoucherForm from "./DynamicVoucher";
const VendorDashboard = ({ voucher, tokens }) => {
  const [showCreateVoucher, setShowCreateVoucher] = useState(false);

  const handleUpload = () => {
    console.log("praveen kkko", voucher, tokens);
    getFieldsValue({
      tokens,
      voucherId: voucher.id,
    });
    setShowCreateVoucher(true);
  };

  const [getFieldsValue, { data: formConfig }] = useLazyGetFieldsValueQuery();

  useEffect(() => {
    console.log("praveen kkko", voucher, tokens);
    getFieldsValue({
      tokens,
      voucherId: voucher.id,
    });
  }, []);
  return (
    <div className={``}>
      {/* {voucher.name} */}

      <ReactTableComponent
        tablename={<span>{voucher.name}</span>}
        // headers = {{}}
        body={[
          { id: 1, name: "dummy Row", date: "2023-01-01" },
          { id: 2, name: "dummy Row", date: "2023-01-01" },
          { id: 3, name: "dummy Row", date: "2023-01-01" },
          { id: 4, name: "dummy Row", date: "2023-01-01" },
        ]}
        actionColumn={<div>AI Upload</div>}
        actionField={
          <div className="bg-white p-2 border-y-2-[#335678] rounded-lg cursor-pointer " onClick={() => handleUpload()}>
            {" "}
            + Add New{" "}
          </div>
        }
      />

      {showCreateVoucher && (
        <Dialog open={showCreateVoucher} onClose={() => setShowCreateVoucher(false)} fullScreen className="!z-[10000]">
          <div className="flex justify-between mx-10 mt-2">
            <span className="text-2xl font-500">{voucher.name}</span>
            <i className="bi bi-x hover:text-red-400 text-2xl" onClick={() => setShowCreateVoucher(false)}></i>
          </div>
          <div className="py-5">
            {formConfig && <DynamicVoucherForm formConfig={formConfig?.data} voucher={voucher} />}
          </div>
        </Dialog>
      )}
    </div>
  );
};

export default VendorDashboard;
